/*
 * @Author: chengyu
 * @Date: 2022-10-28 15:15:24
 * @Description: 异常类型
 * 参考：https://gitlab.hellobike.cn/Carfee/AppBaseAliMP/blob/master/utils/error.js
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isObject, isString } from './is';
/**
 * 获取`message`
 */
function getMessage(opt) {
    if (isString(opt))
        return opt;
    return isObject(opt) ? opt.message : '';
}
/**
 * 网络请求错误
 */
var NetworkError = /** @class */ (function (_super) {
    __extends(NetworkError, _super);
    function NetworkError(options) {
        var _this = _super.call(this, getMessage(options)) || this;
        _this.name = 'NetworkError';
        if (isObject(options)) {
            _this.response = options.response;
            _this.fetchData = options.fetchData;
        }
        return _this;
    }
    return NetworkError;
}(Error));
export { NetworkError };
// 用于业务流程异常和手动抛出异常
var BusinessError = /** @class */ (function (_super) {
    __extends(BusinessError, _super);
    function BusinessError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'BusinessError';
        return _this;
    }
    return BusinessError;
}(Error));
export { BusinessError };
// 只抛出异常，不发埋点，不给用户提示，用于中断流程
var SilentError = /** @class */ (function (_super) {
    __extends(SilentError, _super);
    function SilentError(options) {
        var _this = _super.call(this, getMessage(options)) || this;
        _this.name = 'SilentError';
        if (isObject(options)) {
            // 明确是否需要中断流程的标记
            _this.break = options.break;
        }
        return _this;
    }
    return SilentError;
}(Error));
export { SilentError };
export function createNetworkError(options) {
    return new NetworkError(options);
}
export function createSilentError(options) {
    return new SilentError(options);
}
export function createBusinessError(message) {
    return new BusinessError(message);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29yZS91dGlscy9lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7R0FLRzs7Ozs7Ozs7Ozs7Ozs7OztBQU1ILE9BQU8sRUFBRSxRQUFRLEVBQUUsUUFBUSxFQUFFLE1BQU0sTUFBTSxDQUFDO0FBZTFDOztHQUVHO0FBQ0gsU0FBUyxVQUFVLENBQUMsR0FBUTtJQUMxQixJQUFJLFFBQVEsQ0FBQyxHQUFHLENBQUM7UUFBRSxPQUFPLEdBQUcsQ0FBQztJQUM5QixPQUFPLFFBQVEsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO0FBQzFDLENBQUM7QUFFRDs7R0FFRztBQUNIO0lBQWtDLGdDQUFLO0lBSXJDLHNCQUFZLE9BQXVCO1FBQW5DLFlBQ0Usa0JBQU0sVUFBVSxDQUFDLE9BQU8sQ0FBQyxDQUFDLFNBTTNCO1FBTEMsS0FBSSxDQUFDLElBQUksR0FBRyxjQUFjLENBQUM7UUFDM0IsSUFBSSxRQUFRLENBQUMsT0FBTyxDQUFDLEVBQUU7WUFDckIsS0FBSSxDQUFDLFFBQVEsR0FBRyxPQUFPLENBQUMsUUFBUSxDQUFDO1lBQ2pDLEtBQUksQ0FBQyxTQUFTLEdBQUcsT0FBTyxDQUFDLFNBQVMsQ0FBQztTQUNwQzs7SUFDSCxDQUFDO0lBQ0gsbUJBQUM7QUFBRCxDQUFDLEFBWkQsQ0FBa0MsS0FBSyxHQVl0Qzs7QUFFRCxrQkFBa0I7QUFDbEI7SUFBbUMsaUNBQUs7SUFDdEMsdUJBQVksT0FBZ0I7UUFBNUIsWUFDRSxrQkFBTSxPQUFPLENBQUMsU0FFZjtRQURDLEtBQUksQ0FBQyxJQUFJLEdBQUcsZUFBZSxDQUFDOztJQUM5QixDQUFDO0lBQ0gsb0JBQUM7QUFBRCxDQUFDLEFBTEQsQ0FBbUMsS0FBSyxHQUt2Qzs7QUFFRCwyQkFBMkI7QUFDM0I7SUFBaUMsK0JBQUs7SUFHcEMscUJBQVksT0FBMkI7UUFBdkMsWUFDRSxrQkFBTSxVQUFVLENBQUMsT0FBTyxDQUFDLENBQUMsU0FPM0I7UUFOQyxLQUFJLENBQUMsSUFBSSxHQUFHLGFBQWEsQ0FBQztRQUUxQixJQUFJLFFBQVEsQ0FBQyxPQUFPLENBQUMsRUFBRTtZQUNyQixnQkFBZ0I7WUFDaEIsS0FBSSxDQUFDLEtBQUssR0FBRyxPQUFPLENBQUMsS0FBSyxDQUFDO1NBQzVCOztJQUNILENBQUM7SUFDSCxrQkFBQztBQUFELENBQUMsQUFaRCxDQUFpQyxLQUFLLEdBWXJDOztBQUVELE1BQU0sVUFBVSxrQkFBa0IsQ0FBQyxPQUF1QjtJQUN4RCxPQUFPLElBQUksWUFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0FBQ25DLENBQUM7QUFFRCxNQUFNLFVBQVUsaUJBQWlCLENBQUMsT0FBMkI7SUFDM0QsT0FBTyxJQUFJLFdBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUNsQyxDQUFDO0FBRUQsTUFBTSxVQUFVLG1CQUFtQixDQUFDLE9BQWdCO0lBQ2xELE9BQU8sSUFBSSxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUM7QUFDcEMsQ0FBQyJ9